import jsx from '../lib/jsx'
import { dispatchEvent } from '../lib/helpers'

addEventListener('DOMContentLoaded', () => {
	const currentDivs = document.querySelectorAll('div.invoice_agenda div.current')
	for (let a = 0; a < currentDivs.length; a++) {
		scrollToCurrent(currentDivs[a])
	}
})

export default function scrollToCurrent(element) {

	const parent = element.parentNode.parentNode
	const divPosition = element.offsetLeft - 270

	parent.scroll({
		left: divPosition,
		behavior: 'smooth'
	})
}

